import { render } from "./PropertyPage.vue?vue&type=template&id=5ac002e9&ts=true"
import script from "./PropertyPage.vue?vue&type=script&lang=ts"
export * from "./PropertyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__